module.exports = __webpack_public_path__ + "img/therapy--active.296d0a8d.svg";